var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.state ? _c('div', {
    staticClass: "tvl_layer tvl_layer_login"
  }, [_c('div', {
    staticClass: "tvl_bd"
  }, [_c('div', {
    staticClass: "tvl_login"
  }, [_c('div', {
    staticClass: "tvl_login_tit"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "tvl_login_btn"
  }, [_c('a', {
    staticClass: "tvl_login_qq",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.loginByQQ
    }
  }, [_c('i', {
    staticClass: "tvl_icon_qq"
  }), _vm._v("QQ登录")]), _c('a', {
    staticClass: "tvl_login_wx",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.loginByWx
    }
  }, [_c('i', {
    staticClass: "tvl_icon_wx"
  }), _vm._v("微信登录")])])]), _c('div', {
    staticClass: "tvl_btn"
  }, [_c('a', {
    staticClass: "tvl_btn_a",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("取     消")])])])]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };